import React, { useEffect } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { object, string, date } from "yup";
import { Formik } from "formik";
import { API } from "../../../api/API";
import { useState } from "react";
import { InputGroup, Modal } from "react-bootstrap";
import Button from "@mui/material/Button";
import { Box, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import frLocale from "date-fns/locale/fr";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ToastContainer, toast } from "react-toastify";
import Divider from "@mui/material/Divider";
import { appColors } from "../../../constant/constant";
import useAuthStore from "../../../store/authStore";

const RegisterPersonnel = ({ onRefresh }) => {
  const [show, setShow] = useState(false);
  const user = useAuthStore((state) => state.user);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // Schéma de validation avec tous les champs de document obligatoires
  const assureSchema = object({
    nom: string().required("Ce champ est requis"),
    prenom: string().required("Ce champ est requis"),
    email: string().email("Email invalide"),
    tel: string()
      .required("Ce champ est requis")
      .matches(/^[0-9]+$/, "Doit contenir uniquement des chiffres")
      .min(8, "Doit contenir au moins 8 chiffres"),
    adresse: string(),
    date_naissance: date().nullable().required("Ce champ est requis"),
    genre: string().required(),
    role: string().required(),

    type_document_id: string().required("Ce champ est requis"),
    numero_document_id: string().required("Ce champ est requis"),
    date_delivre: date().nullable().required("Ce champ est requis"),
    lieu_delivre: string().required("Ce champ est requis"),
  });

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />

      <Button
        variant="outlined"
        color="success"
        sx={{
          "&:hover": { backgroundColor: "#2e8b3a" },
          borderRadius: "8px",
          padding: "8px 16px",
          textTransform: "none",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
        onClick={handleShow}
        startIcon={<span style={{ fontSize: "1.2rem" }}>+</span>}
      >
        <Typography variant="subtitle1">Nouvel personnel</Typography>
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-success text-light">
          <Modal.Title id="contained-modal-title-vcenter">
            <Typography variant="h6" component="h2" color="inherit">
              Enregistrement d'un nouveau personel
            </Typography>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Box sx={{ maxHeight: "70vh", overflowY: "auto", padding: "0 16px" }}>
            <Formik
              validationSchema={assureSchema}
              initialValues={{
                nom: "",
                prenom: "",
                tel: "",
                adresse: "",
                email: "",
                role: "agent_assurance",
                genre: "homme",
                date_naissance: null,
                type_document_id: "",
                numero_document_id: "",
                date_delivre: null,
                lieu_delivre: "",
              }}
              onSubmit={async (values, { setSubmitting, resetForm }) => {
                const toastId = toast.loading("Enregistrement en cours...");
                try {
                  await API.post("/assurance/agents", {
                    ...values,
                    created_by: user?.id,
                  });
                  toast.update(toastId, {
                    render: "personnel créé avec succès!",
                    type: "success",
                    isLoading: false,
                    autoClose: 2000,
                  });
                  resetForm();
                  onRefresh();
                  //handleClose();
                } catch (error) {
                  let errorMessage = "Erreur lors de la création du personnel";

                  if (error.response) {
                    errorMessage =
                      error.response.data.message ||
                      `${error.response.status}: ${JSON.stringify(
                        error.response.data.error
                      )}`;
                  } else if (error.request) {
                    errorMessage = "Pas de réponse du serveur";
                  }

                  toast.update(toastId, {
                    render: errorMessage,
                    type: "error",
                    isLoading: false,
                    autoClose: 2000,
                  });
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {({
                values,
                errors,
                setFieldValue,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                resetForm,
                isSubmitting,
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <Divider sx={{ color: appColors.secondary }}>
                    Informations personnelles
                  </Divider>

                  <Row className="mb-3">
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Nom <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="nom"
                        required
                        type="text"
                        value={values.nom}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Votre nom"
                        isInvalid={touched.nom && !!errors.nom}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.nom}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Prénom <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="prenom"
                        required
                        type="text"
                        value={values.prenom}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Prénom"
                        isInvalid={touched.prenom && !!errors.prenom}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.prenom}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        name="email"
                        type="email"
                        placeholder="Email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.email && !!errors.email}
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Téléphone <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="tel"
                        type="tel"
                        placeholder="Numéro de téléphone"
                        value={values.tel}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.tel && !!errors.tel}
                        required
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.tel}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Date de naissance{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={frLocale}
                      >
                        <DatePicker
                          value={values.date_naissance}
                          onChange={(date) =>
                            setFieldValue("date_naissance", date)
                          }
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error:
                                touched.date_naissance &&
                                !!errors.date_naissance,
                              helperText:
                                touched.date_naissance && errors.date_naissance,
                              variant: "outlined",
                              size: "small",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Adresse <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="adresse"
                        type="text"
                        placeholder="Adresse"
                        value={values.adresse}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.adresse && !!errors.adresse}
                        required
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.adresse}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>Genre</Form.Label>
                      <Form.Select
                        name="genre"
                        value={values.genre}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.genre && !!errors.genre}
                        required
                        className="rounded-input"
                      >
                        <option value="homme">H</option>
                        <option value="femme">F</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>Role</Form.Label>
                      <Form.Select
                        name="role"
                        value={values.role}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.role && !!errors.role}
                        required
                        className="rounded-input"
                      >
                        <option value="admin_assurance">administrateur</option>
                        <option value="agent_assurance">agent</option>
                        <option value="medecin_assurance">
                          medecin conseille
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Row>

                  {/**information d'identification */}
                  <Divider sx={{ color: appColors.secondary, mt: 3, mb: 3 }}>
                    Informations du document d'identification
                  </Divider>
                  <Row className="mb-3">
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Type de document <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        name="type_document_id"
                        value={values.type_document_id}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.type_document_id && !!errors.type_document_id
                        }
                        required
                        className="rounded-input"
                      >
                        <option value="">
                          Sélectionnez un type de document
                        </option>
                        <option value="passport">Passport</option>
                        <option value="carte d'identité national">
                          Carte d'identité national
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.type_document_id}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Numéro de document{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="numero_document_id"
                        type="text"
                        placeholder="Numéro de document"
                        value={values.numero_document_id}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.numero_document_id &&
                          !!errors.numero_document_id
                        }
                        required
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.numero_document_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Row className="mb-4">
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Date de délivrance{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={frLocale}
                      >
                        <DatePicker
                          value={values.date_delivre}
                          onChange={(date) =>
                            setFieldValue("date_delivre", date)
                          }
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error:
                                touched.date_delivre && !!errors.date_delivre,
                              helperText:
                                touched.date_delivre && errors.date_delivre,
                              variant: "outlined",
                              size: "small",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Form.Group>

                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Lieu de délivrance{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        name="lieu_delivre"
                        type="text"
                        placeholder="Lieu de délivrance"
                        value={values.lieu_delivre}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.lieu_delivre && !!errors.lieu_delivre
                        }
                        required
                        className="rounded-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.lieu_delivre}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 2,
                      mt: 3,
                    }}
                  >
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={handleClose}
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "6px 16px",
                      }}
                    >
                      Annuler
                    </Button>

                    <Button
                      variant="outlined"
                      color="info"
                      onClick={() => resetForm()}
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "6px 16px",
                      }}
                    >
                      Réinitialiser
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      disabled={isSubmitting}
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "6px 24px",
                        backgroundColor: "#37B049",
                        "&:hover": { backgroundColor: "#2e8b3a" },
                      }}
                    >
                      {isSubmitting ? "Enregistrement..." : "Enregistrer"}
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RegisterPersonnel;
